

























    import Vue from 'Vue';
    import Vuex from 'Vuex';
    import { INavigationButton, ThemeEnum, ButtonSizeEnum } from '../../../../../../CommonScripts/Abstractions';
    export default Vue.extend({
        name: 'content-control',
        props: {
            contentControlItem: { type: Object as () => INavigationButton, required: true }
        },
        data() {
            return {showLoading:false};
        },
        computed: {
            dark(): boolean {
                return this.contentControlItem.theme === ThemeEnum.Dark;
            },
            light(): boolean {
                return this.contentControlItem.theme === ThemeEnum.Light;
            },
            small(): boolean {
                return this.contentControlItem.size === ButtonSizeEnum.Small;
            },
            large(): boolean {
                return this.contentControlItem.size === ButtonSizeEnum.Large;
            },
            cssClasses(): string {
                return `mt-2 ${this.$store.getters['textCssClass']} ${this.contentControlItem.cssClasses}`;
            },
            btnAriaLabel(): string { return this.$vuetify.lang.t(this.contentControlItem.ariaLabelKey); },
            btnTooltip(): string { return this.$vuetify.lang.t(this.contentControlItem.tooltipKey); }
        },
        methods: {
            clickHandler() {
                if (this.contentControlItem.showLoading)
                    this.showLoading = true;
                if (this.contentControlItem.clickHandler)
                    this.contentControlItem.clickHandler().then(
                        () => {
                            this.showLoading = false;
                        }
                    );
            }
        }
    });
